<kendo-dialog title="Session expired" *ngIf="show" (close)="show = false" [minWidth]="250" [width]="450">
  <p class="dialog-content">Your session has expired. You will now be signed out.</p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="action.emit(false)" [primary]="true">Okay</button>
  </kendo-dialog-actions>
</kendo-dialog>
